import { gql } from '@apollo/client'

export const GET_FORM_OPTIONS = gql`
  query workOrderFormOptions($propertyId: Int!) {
    createWorkOrderFormOptions(property_id: $propertyId)
  }
`
